const vendorAddAttachment = (function () {
    // Elements test
    let attachmentList, attachmentInput, attachmentContainer, addAttachmentBtn, removeAttachmentBtn;
    let reviewAttachmentList, newAttachmentList;
    // Data
    let vendorId;
    let attachmentsToDelete, reviewAttachmentArray;

    function attachmentPopup() {
        const popup = POPUP.build({
            header: 'Attachments',
            id: 'cnAttachmentPopup',
        });

        addAttachmentBtn = button.build({
            text: 'Add Attachment',
            style: 'secondary',
            type: 'text',
            icon: 'add',
            callback: addNewAttachment,
        });
        addAttachmentBtn.type = 'button';
        removeAttachmentBtn = button.build({
            style: 'secondary',
            type: 'text',
            icon: 'delete',
        });
        removeAttachmentBtn.type = 'button';
        addRemoveAttachmentEventListener(removeAttachmentBtn);
        const saveBtn = button.build({
            id: 'attachmentSave',
            text: 'Done',
            style: 'secondary',
            type: 'contained',
            callback: () => {
                saveAction();
                POPUP.hide(popup);
            },
        });
        const cancelBtn = button.build({
            id: 'attachmentCancel',
            text: 'cancel',
            style: 'secondary',
            type: 'outlined',
            callback: () => {
                POPUP.hide(popup);
            },
        });

        reviewAttachmentList = document.createElement('div');
        reviewAttachmentList.classList.add('reviewAttachmentList');
        newAttachmentList = document.createElement('div');
        newAttachmentList.classList.add('newAttachmentList');
        const newAttachmentsHeader = document.createElement('h5');
        newAttachmentsHeader.innerText = 'Attachments to be added:';
        newAttachmentList.appendChild(newAttachmentsHeader);


        attachmentInput = document.createElement('input');
        attachmentInput.type = 'file';
        attachmentInput.classList.add('input-field__input', 'attachmentInput');
        attachmentInput.onchange = event => fileValidation(event.target);

        attachmentContainer = document.createElement('div');
        attachmentContainer.classList.add('attachmentContainer');
        attachmentList = document.createElement('form');
        attachmentList.setAttribute('id', 'attachmentForm');
        attachmentList.appendChild(attachmentContainer);
        attachmentContainer.appendChild(removeAttachmentBtn);
        attachmentContainer.appendChild(attachmentInput);



        const btnWrap = document.createElement('div');
        btnWrap.classList.add('btnWrap');

        popup.appendChild(reviewAttachmentList);
        popup.appendChild(newAttachmentList);
        popup.appendChild(attachmentList);
        popup.appendChild(addAttachmentBtn);


        btnWrap.appendChild(saveBtn);
        btnWrap.appendChild(cancelBtn);
        popup.appendChild(btnWrap);
        POPUP.show(popup);
    }

    function fileValidation(target) {
        const fileType = target.files[0].type;
        const reFileTypeTest = new RegExp('(audio/)|(video/)');
        if (reFileTypeTest.test(fileType)) {
            alert('Anywhere currently does not accept audio or video files');
            target.value = '';
            return false;
        }
    }

    function addNewAttachment() {
        // Don't add new attachment input if the last attachment is empty
        const form = document.getElementById('attachmentForm');
        const lastAttachment = form.lastChild;
        if (lastAttachment && lastAttachment.querySelector('.attachmentInput').value === '') {
            return;
        }
        const newFileContainer = attachmentContainer.cloneNode(true);
        newFileContainer.getElementsByTagName('input')[0].value = ''; //remove file for new container
        newFileContainer.getElementsByTagName('input')[0].onchange = event =>
            fileValidation(event.target);
        attachmentList.appendChild(newFileContainer);
        addRemoveAttachmentEventListener(newFileContainer.firstElementChild);
        attachmentContainer = newFileContainer;
    }

    function addRemoveAttachmentEventListener(btn) {
        btn.addEventListener('click', event => {
            const fileInput = event.target.parentElement.getElementsByTagName('input')[0];
            if (fileInput !== '') {
                event.target.parentElement.remove();
            }
        });
    }

    function saveAction() {
        const attachmentInputs = document.querySelectorAll('.attachmentInput');
        if (attachmentInputs.length === 0) {
            return;
        }

        let attachmentProms = [];
        let attachmentArray = [];
        attachmentInputs.forEach(inputElement => {
            if (inputElement.value === '') {
                return;
            }
            const attPromise = new Promise(resolve => {
                const attachmentObj = {};
                const attachmentFile = inputElement.files.item(0);
                const attachmentName = attachmentFile.name;
                const attachmentType = attachmentFile.name.split('.').pop();
                attachmentObj.description = attachmentName;
                attachmentObj.type = attachmentType;
                // new Response(file) was added for Safari compatibility
                new Response(attachmentFile).arrayBuffer().then(res => {
                    attachmentObj.arrayBuffer = res;
                    attachmentArray.push(attachmentObj);
                    resolve();
                });
            });

            attachmentProms.push(attPromise);
        });

        Promise.all(attachmentProms).then(res => {
            attachmentsToDelete.forEach(remAttachment => {
                reviewAttachmentArray = reviewAttachmentArray.filter(
                    attachment => attachment.attachmentId !== remAttachment,
                );
            });

            saveAttachments(attachmentArray);

        });
    }

    function saveAttachments(attachmentArray) {
        const saveAttachmentPromArray = [];
        attachmentArray.forEach(attachment => {
            const promise = new Promise((resolve, reject) => {
                authorizationsAjax.addVenderAttachment(
                    vendorId,
                    attachment.description,
                    attachment.type,
                    attachment.arrayBuffer,
                    res => {
                        resolve();
                    },
                );
            });
            saveAttachmentPromArray.push(promise);
        });

        Promise.all(saveAttachmentPromArray).then(res => {
            vendorAttachments.refreshPage(); 
        });
    }

    function populateExistingAttachments(reviewAttachments) {
        const existingPopup = POPUP.build({
            header: 'Attachment', 
            id: 'cnAttachmentPopup',
        });
        const reviewAttachList = document.createElement('div');
        reviewAttachList.classList.add('reviewAttachmentList');


        reviewAttachments.forEach(attachment => {
            const fileContainer = document.createElement('div');
            fileContainer.classList.add('reviewAttachmentContainer');
            fileContainer.setAttribute('id', attachment.attachmentId);
         
            const file = document.createElement('p');
            file.innerText = attachment.description;


            fileContainer.appendChild(file);
            file.addEventListener('click', event => {
                const attachmentId = event.target.parentElement.id;
                authorizationsAjax.viewVendorAttachment(attachmentId);
            });
            reviewAttachList.appendChild(fileContainer); 
        });

        const cancelBtn = button.build({
            id: 'attachmentCancel',
            text: 'cancel',
            style: 'secondary',
            type: 'outlined',
            callback: () => {
                POPUP.hide(existingPopup);
            },
        });
        cancelBtn.style.width = '100%';
        cancelBtn.style.marginTop = '20px';

        existingPopup.appendChild(reviewAttachList);
        existingPopup.appendChild(cancelBtn);
        POPUP.show(existingPopup);
    }

    function init(reviewAttachments, vendorID) {
        vendorId = vendorID;
        attachmentsToDelete = [];
        reviewAttachmentArray = reviewAttachments;       
        if (reviewAttachments.length !== 0) {
            populateExistingAttachments(reviewAttachments);
        } else {
            attachmentPopup(); 
        }
    }

    return {
        init,
    };
})();
